import { useLocation, useNavigate } from 'react-router-dom'
import {
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  increment,
  query,
  setDoc,
  where,
  writeBatch
} from 'firebase/firestore'
import { useEffect, useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Link,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import {
  Close,
  Comment,
  CommentsDisabled,
  ContactSupport,
  FirstPage,
  History,
  Info,
  Login,
  Refresh
} from '@mui/icons-material'
import { PaperComponent } from '../Helpers/Drag'
import Loading from '../Helpers/Loading'
import noData from '../../Icons/noData.jpg'
import warning from '../../Icons/warning.jpg'
import polls from '../../Icons/polls.png'
import ViewPulseBody from './ViewPulseBody'
import RTEView from '../RichTextEditor/RTEView'
import PulseAdminMenu from './Helpers/PulseAdminMenu'

const ViewPulse = ({
  uid,
  db,
  displayName,
  email,
  setSavedLocation,
  isPreview
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location
  const [document, setDocument] = useState(null)
  const [alert, setAlert] = useState(null)
  const [isAllowedToView, setIsAllowedToView] = useState(false)
  const [isAllowedToComment, setIsAllowedToComment] = useState(false)
  const [isAllowedToCommentEver, setIsAllowedToCommentEver] = useState(true)
  const [isAdmin, setIsAdmin] = useState(false)
  const [comments, setComments] = useState([])
  const [accessCode, setAccessCode] = useState('')
  const [entryAccessCode, setEntryAccessCode] = useState('')
  const [entryAccessCodeConfirmed, setEntryAccessCodeConfirmed] = useState(true)
  const [showSignInAlert, setShowSignInAlert] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const [loading, setLoading] = useState(true)

  let today = Date.now()

  function getDate (date) {
    return new Date(date.toDate())
  }

  useEffect(() => {
    async function getDocument () {
      setLoading(true)
      var result = pathname.substring(pathname.lastIndexOf('/') + 1)
      const docRef = doc(db, 'sliders', result)
      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) {
        let data = docSnap.data()
        data.id = docSnap.id
        setDocument(data)

        if (uid && email.length > 0 && displayName.length > 0) {
          await getDoc(doc(db, 'users', uid)).then(val => {
            let data2 = val.data()
            if (!data2.visited || data2.visited.length < 2) {
              setShowInfo(true)
            }
          })
          await setDoc(
            doc(db, 'users', uid),
            {
              visited: arrayUnion(data.id)
            },
            { merge: true }
          )
          await setDoc(
            doc(db, 'sliders', data.id),
            {
              visited: data.visited ? data.visited + 1 : 1,
              visitedBy: arrayUnion({
                uid: uid,
                displayName: displayName,
                email: email
              })
            },
            { merge: true }
          )
          setLoading(false)
          setIsAllowedToCommentEver(true)

          setShowSignInAlert(false)
          setTimeout(() => {
            setShowSignInAlert(false)
          }, 2000)
        } else {
          setLoading(false)
          setIsAllowedToCommentEver(false)
        }
      } else {
        let q1 = query(
          collection(db, 'sliders'),
          where('customRoute', '==', result)
        )
        const querySnapshot = await getDocs(q1)
        if (querySnapshot.docs.length === 0) {
          setLoading(false)
          setAlert('No such pulse!')
        } else {
          querySnapshot.forEach(async docSnap => {
            let data = docSnap.data()
            data.id = docSnap.id
            setDocument(data)

            if (uid && email.length > 0 && displayName.length > 0) {
              await getDoc(doc(db, 'users', uid)).then(val => {
                let data2 = val.data()
                if (!data2.visited || data2.visited.length < 2) {
                  setShowInfo(true)
                }
              })
              await setDoc(
                doc(db, 'users', uid),
                {
                  visited: arrayUnion(data.id)
                },
                { merge: true }
              )
              await setDoc(
                doc(db, 'sliders', data.id),
                {
                  visited: data.visited ? data.visited + 1 : 1,
                  visitedBy: arrayUnion({
                    uid: uid,
                    displayName: displayName,
                    email: email
                  })
                },
                { merge: true }
              )
              setLoading(false)
              setIsAllowedToCommentEver(true)

              setShowSignInAlert(false)
              setTimeout(() => {
                setShowSignInAlert(false)
              }, 2000)
            } else {
              setLoading(false)
              setIsAllowedToCommentEver(false)
            }
          })
        }
      }
    }

    if (uid && email.length > 0 && displayName.length > 0) {
      setIsAllowedToCommentEver(true)
    }
    setDocument(null)
    getDocument()
  }, [uid, displayName, email, pathname])

  useEffect(() => {
    async function anonView () {
      if (!uid && email.length === 0 && displayName.length === 0 && document) {
        await setDoc(
          doc(db, 'sliders', document.id),
          {
            visited: increment(1)
          },
          { merge: true }
        )
      }
    }

    setTimeout(() => {
      setShowSignInAlert(true)
    }, 2000)

    setTimeout(() => {
      anonView()
    }, 10000)
  }, [])

  function handleEntryAccessCode (e) {
    let val = e.target.value
    setEntryAccessCode(val)
  }

  const revertUserResponses = async () => {
    const batch = writeBatch(db)
    const userComments = comments.filter(comment => comment.uid === uid)
    const docRef = doc(db, 'sliders', document.id)

    userComments.forEach(comment => {
      batch.update(docRef, {
        comments: arrayRemove(comment),
        commentCount: increment(-1)
      })
    })

    await batch.commit()
    navigate('/viewPulse/' + getRoute())
  }

  async function setCommentDB (commentDB, comment, add = true, callback) {
    setComments(commentDB)
    const docRef = doc(db, 'sliders', document.id)
    if (add) {
      await setDoc(
        docRef,
        {
          comments: arrayUnion(comment),
          commentCount: increment(1)
        },
        { merge: true }
      )
      await setDoc(
        doc(db, 'users', uid),
        {
          commentedOn: arrayUnion(document.id)
        },
        { merge: true }
      )
    } else {
      await setDoc(
        docRef,
        {
          comments: arrayRemove(comment),
          commentCount: increment(-1)
        },
        { merge: true }
      )
    }
    if (typeof callback === 'function') {
      callback()
    }
  }

  useEffect(() => {
    if (document) {
      setComments(document.comments || [])
      if (
        document.uid === uid ||
        (document.admins && document.admins.includes(uid))
      ) {
        setIsAdmin(true)
        setIsAllowedToComment(true)
        setIsAllowedToView(true)
        if (isPreview) {
          if (
            today >= getDate(document.visibleDate.startDate) &&
            today <= getDate(document.visibleDate.endDate)
          ) {
            if (document.commentDate) {
              if (
                !(
                  today >= getDate(document.commentDate.startDate) &&
                  today <= getDate(document.commentDate.endDate)
                )
              ) {
                setIsAllowedToComment(false)
              }
            } else {
              setIsAllowedToComment(false)
            }
          } else {
            setIsAllowedToView(false)
            setIsAllowedToComment(false)
          }
        }
        return
      }

      if (typeof document.draft === 'undefined' && document.draft === true) {
        navigate('/search')
      } else {
        if (document.viewCode) {
          setAccessCode(document.viewCode)
          if (
            document.accessApproved &&
            document.accessApproved.includes(uid)
          ) {
            setEntryAccessCodeConfirmed(true)
          } else {
            if (
              window.sessionStorage.getItem('accessCode') !== null &&
              window.sessionStorage.getItem('accessCode') === document.viewCode
            ) {
              setEntryAccessCodeConfirmed(true)
            } else {
              setEntryAccessCodeConfirmed(false)
            }
          }
        }

        if (
          today >= getDate(document.visibleDate.startDate) &&
          today <= getDate(document.visibleDate.endDate)
        ) {
          if (document.signInView && !uid) {
            setIsAllowedToView(false)
          } else {
            setIsAllowedToView(true)
          }
          if (document.commentDate) {
            if (
              today >= getDate(document.commentDate.startDate) &&
              today <= getDate(document.commentDate.endDate)
            ) {
              setIsAllowedToComment(true)
            }
          }
        }
      }
    } else {
      setIsAdmin(false)
      setIsAllowedToComment(false)
      setIsAllowedToView(false)
      setComments([])
    }
  }, [document])

  const getRoute = () => {
    return document.customRoute.length > 0 ? document.customRoute : document.id
  }

  return (
    <Stack sx={{ pb: 2 }}>
      {alert && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            width: { md: '50%', xs: '90%' },
            margin: 'auto',
            mt: 6
          }}
        >
          <img
            src={noData}
            alt='Cannot Find Pulse'
            style={{ borderRadius: '4px', width: '100%' }}
          />
          <Typography variant='h3' sx={{ fontWeight: 'bold' }}>
            Cannot Find Pulse
          </Typography>
        </Box>
      )}
      {loading && <Loading padding='50px 0' margin='50px auto' />}
      {!loading && document && (
        <>
          <ViewTopCard
            db={db}
            uid={uid}
            accessCode={accessCode}
            entryAccessCode={entryAccessCode}
            setEntryAccessCodeConfirmed={setEntryAccessCodeConfirmed}
            entryAccessCodeConfirmed={entryAccessCodeConfirmed}
            handleEntryAccessCode={handleEntryAccessCode}
            document={document}
            setShowInfo={setShowInfo}
            isPreview={isPreview}
            isAdmin={isAdmin}
          />

          {isPreview && (
            <Box
              sx={{
                m: { md: 2, xs: 1 },
                p: { md: 0, xs: 0 },
                mt: '0 !important'
              }}
            >
              <Alert
                variant='filled'
                onClick={revertUserResponses}
                severity='error'
                action={
                  <Button color='inherit' size='small'>
                    <FirstPage />
                    BACK
                  </Button>
                }
              >
                You are in PREVIEW mode. Click here to go back to the admin view
                and remove all of your responses.{' '}
                <b>
                  If you navigate away or take any other actions (like deleting
                  other users' responses) while in preview mode, your changes
                  will be saved.
                </b>
              </Alert>
            </Box>
          )}
          {document.commentDate && entryAccessCodeConfirmed && (
            <>
              {!(
                today >= getDate(document.commentDate.startDate) &&
                today <= getDate(document.commentDate.endDate)
              ) &&
              today >= getDate(document.visibleDate.startDate) &&
              today <= getDate(document.visibleDate.endDate) ? (
                <Box
                  sx={{
                    m: { md: 2, xs: 1 },
                    p: { md: 0, xs: 0 },
                    mt: '0 !important'
                  }}
                >
                  <Alert
                    variant={!isPreview ? 'filled' : undefined}
                    severity='error'
                    sx={{ alignItems: 'center' }}
                    icon={<Comment fontSize='inherit' />}
                  >
                    {today <= getDate(document.commentDate.startDate)
                      ? "Commenting Period Hasn't Started"
                      : 'Commenting Period Has Ended'}
                  </Alert>
                </Box>
              ) : (
                <>
                  {' '}
                  {showSignInAlert && !isAllowedToCommentEver && !uid && (
                    <Box
                      sx={{
                        m: { md: '10px auto', xs: 'auto' },
                        width: { md: '90vw', xs: '95%' },
                        p: { md: '0', xs: '0' }
                      }}
                    >
                      <Alert
                        variant={!isPreview ? 'filled' : undefined}
                        severity='error'
                        sx={{ alignItems: 'center' }}
                        icon={<Login fontSize='inherit' />}
                        action={
                          <Stack alignItems='center' direction='row'>
                            <Button
                              color='inherit'
                              onClick={() => {
                                setSavedLocation(window.location.pathname)
                                navigate('/signup')
                              }}
                              size='small'
                            >
                              Sign Up
                            </Button>
                            <IconButton
                              color='inherit'
                              onClick={() => setShowSignInAlert(false)}
                            >
                              <Close />
                            </IconButton>
                          </Stack>
                        }
                      >
                        Sign Up to Comment
                      </Alert>
                    </Box>
                  )}
                </>
              )}
            </>
          )}

          {!(
            today >= getDate(document.visibleDate.startDate) &&
            today <= getDate(document.visibleDate.endDate)
          ) && (
            <Box
              sx={{
                m: { md: '10px auto', xs: 'auto' },
                width: { md: '90vw', xs: '95%' },
                p: { md: '0', xs: '0' },
                textAlign: 'center',
                gap: { md: '24px', xs: '16px' },
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Alert
                variant={!isPreview ? 'filled' : undefined}
                severity='error'
                sx={{ alignItems: 'center' }}
                icon={<History fontSize='inherit' />}
              >
                {today <= getDate(document.visibleDate.startDate)
                  ? "Viewing Period Hasn't Started"
                  : 'Viewing Period Has Ended'}
              </Alert>
              {(!isAdmin || isPreview) && (
                <img
                  src={warning}
                  alt={
                    today <= getDate(document.visibleDate.startDate)
                      ? "Viewing Period Hasn't Started"
                      : 'Viewing Period Has Ended'
                  }
                  style={{
                    borderRadius: '4px',
                    width: 'max(40%, 250px)',
                    margin: 'auto'
                  }}
                />
              )}
            </Box>
          )}

          {isAllowedToView && entryAccessCodeConfirmed && (
            <ViewPulseBody
              pulse={document}
              uid={uid}
              comments={isAllowedToCommentEver ? comments : []}
              setComments={setCommentDB}
              isAllowedToComment={
                typeof document.commentDate !== 'undefined' &&
                isAllowedToCommentEver &&
                isAllowedToComment
              }
              displayName={displayName}
              showInfo={showInfo}
              setShowInfo={setShowInfo}
              isPreview={isPreview}
            />
          )}
        </>
      )}
    </Stack>
  )
}

const ViewTopCard = ({
  db,
  uid,
  accessCode,
  entryAccessCode,
  setEntryAccessCodeConfirmed,
  entryAccessCodeConfirmed,
  handleEntryAccessCode,
  document,
  setShowInfo,
  isPreview,
  isAdmin
}) => {
  const [showInfoModal, setShowInfoModal] = useState(false)
  const [showAccessCodeFailed, setShowAccessCodeFailed] = useState(false)

  async function checkViewCode () {
    const accessApproved = accessCode === entryAccessCode
    setEntryAccessCodeConfirmed(accessApproved)
    setShowAccessCodeFailed(!accessApproved)
    if (accessApproved && uid) {
      const docRef = doc(db, 'sliders', document.id)
      await setDoc(
        docRef,
        {
          accessApproved: arrayUnion(uid)
        },
        { merge: true }
      )
    }
    if (accessApproved) {
      window.sessionStorage.setItem('accessCode', entryAccessCode)
    }
  }

  function getDateString (date) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(date.toDate()).toLocaleDateString(undefined, options)
  }

  function getComboDateString (obj) {
    return getDateString(obj.startDate) + ' - ' + getDateString(obj.endDate)
  }

  function isDraftCheck (document) {
    return typeof document.draft !== 'undefined' && document.draft === true
  }

  useEffect(() => {
    window.document.title = document.fileName
  }, [document])

  return (
    <Box
      sx={{
        m: { md: 2, xs: '16px 8px 16px' }
      }}
    >
      <Card raised>
        <CardHeader
          sx={{
            flexWrap: 'wrap',
            rowGap: 1,
            '& .MuiCardHeader-action': { ml: 'auto' }
          }}
          action={
            <Stack
              useFlexGap
              flexWrap='wrap'
              direction={'row'}
              sx={{
                alignItems: 'center',
                ml: 'auto'
              }}
            >
              <Tooltip title='Only Visible to Admins'>
                <span>
                  <Chip
                    label='DRAFT'
                    color='error'
                    sx={{
                      ml: 2,
                      display: isDraftCheck(document) ? '' : 'none'
                    }}
                  />
                  <Chip
                    label='Preview Mode'
                    color='error'
                    sx={{
                      ml: 2,
                      display: isPreview ? '' : 'none'
                    }}
                  />
                  <Chip
                    label='Admin'
                    color='secondary'
                    sx={{
                      ml: 2,
                      display: isAdmin && !isPreview ? '' : 'none'
                    }}
                  />
                </span>
              </Tooltip>
              {window.innerWidth < 800 && (
                <Tooltip title='Reload Page'>
                  <IconButton
                    aria-label='reload'
                    onClick={() => window.location.reload()}
                  >
                    <Refresh />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title='Pulse Usage Directions'>
                <IconButton
                  sx={{ placeSelf: 'end' }}
                  color='secondary'
                  onClick={() => setShowInfo(true)}
                >
                  <ContactSupport />
                </IconButton>
              </Tooltip>

              <Tooltip title='More Pulse Information'>
                <IconButton
                  aria-label='info'
                  onClick={() => setShowInfoModal(true)}
                >
                  <Info />
                </IconButton>
              </Tooltip>
              {typeof document.commentDate === 'undefined' && (
                <Tooltip title='Comments Turned Off'>
                  <IconButton>
                    <CommentsDisabled />
                  </IconButton>
                </Tooltip>
              )}
              <Dialog
                open={showInfoModal}
                onClose={() => setShowInfoModal(false)}
                PaperComponent={PaperComponent}
                aria-labelledby='draggable-dialog-title'
                fullWidth
              >
                <DialogTitle style={{ cursor: 'move' }}>
                  {document.fileName} Information
                </DialogTitle>
                <DialogContent>
                  <Stack spacing={2}>
                    <Typography variant='span'>
                      <span style={{ fontWeight: '600' }}>
                        {'Organization: '}
                      </span>
                      {document.displayName}
                    </Typography>
                    {document.hostName && (
                      <Typography variant='span'>
                        <span style={{ fontWeight: '600' }}>{'Host: '}</span>{' '}
                        {document.hostName}
                      </Typography>
                    )}
                    {document.description &&
                      document.description.length > 0 &&
                      document.description !== '<p></p>' && (
                        <Typography
                          component='h5'
                          sx={{ whiteSpace: 'pre-line' }}
                        >
                          <span style={{ fontWeight: '600' }}>
                            Description:
                          </span>
                          <RTEView content={document.description} />
                        </Typography>
                      )}
                    {document.contactInformation &&
                      document.contactInformation.length > 0 && (
                        <>
                          <Typography
                            component='h5'
                            sx={{ overflowWrap: 'break-word' }}
                          >
                            <span style={{ fontWeight: '600' }}>
                              {'Contact Information: '}
                            </span>
                            {document.contactInformation}
                          </Typography>
                        </>
                      )}
                    {document.contactLink && (
                      <>
                        <Typography
                          component='h5'
                          sx={{ overflowWrap: 'break-word' }}
                        >
                          <span style={{ fontWeight: '600' }}>
                            {'Contact Link: '}
                          </span>
                          {document.contactLink.includes('@') ? (
                            <Link
                              href={
                                'mailto:' +
                                document.contactLink +
                                '?subject=' +
                                document.fileName
                              }
                              target='_blank'
                              rel='noreferrer'
                            >
                              {document.contactLink}
                            </Link>
                          ) : (
                            <Link
                              href={document.contactLink}
                              target='_blank'
                              rel='noreferrer'
                            >
                              {document.contactLink}
                            </Link>
                          )}
                        </Typography>
                      </>
                    )}
                    <Typography variant='span'>
                      <span style={{ fontWeight: '600' }}>{'Live: '}</span>
                      {getComboDateString(document.visibleDate)}
                    </Typography>
                    {document.commentDate && (
                      <>
                        <Typography variant='span'>
                          <span style={{ fontWeight: '600' }}>
                            {'Comment Between: '}
                          </span>
                          {getComboDateString(document.commentDate)}
                        </Typography>
                        <Typography variant='span' sx={{ fontStyle: 'italic' }}>
                          {!document.commentVisibility
                            ? 'Users can only see their own comments'
                            : "Users can see everyone's comments"}
                        </Typography>
                      </>
                    )}
                  </Stack>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant='outlined'
                    onClick={() => setShowInfoModal(false)}
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
              {(document.uid === uid ||
                (document.admins && document.admins.includes(uid))) &&
                window === window.parent &&
                !isPreview && (
                  <PulseAdminMenu
                    isDraftCheck={isDraftCheck}
                    db={db}
                    document={document}
                  />
                )}
            </Stack>
          }
          avatar={
            document.logoURL ? (
              <img
                alt='document logo'
                src={document.logoURL}
                style={{
                  height: '100px',
                  marginRight: '10px',
                  maxWidth: '30vw',
                  objectFit: 'contain'
                }}
              />
            ) : (
              <img
                alt='pulse branded moment'
                src={polls}
                style={{
                  height: '100px',
                  marginRight: '10px',
                  maxWidth: '30vw',
                  objectFit: 'contain'
                }}
              />
            )
          }
          title={document.fileName}
          subheader={
            document.displayName +
            (document.hostName ? ' (' + document.hostName + ') ' : '')
          }
          className='viewCardHeader'
        />
        <CardContent className='viewCardDetail'>
          <Stack spacing={2}>
            {document.description &&
              document.description.length > 0 &&
              document.description !== '<p></p>' && (
                <Typography variant='span' sx={{ whiteSpace: 'pre-line' }}>
                  <span style={{ fontWeight: '600' }}> Description:</span>
                  <br />
                  <RTEView content={document.description} />
                </Typography>
              )}
            {document.contactInformation &&
              document.contactInformation.length > 0 && (
                <>
                  <Typography
                    variant='span'
                    sx={{ overflowWrap: 'break-word' }}
                  >
                    <span style={{ fontWeight: '600' }}>
                      {'Contact Information: '}
                    </span>
                    {document.contactInformation}
                    <br />
                  </Typography>
                </>
              )}
            {document.contactLink && (
              <>
                <Typography variant='span' sx={{ overflowWrap: 'break-word' }}>
                  <span style={{ fontWeight: '600' }}>{'Contact Link: '}</span>
                  {document.contactLink.includes('@') ? (
                    <Link
                      href={
                        'mailto:' +
                        document.contactLink +
                        '?subject=' +
                        document.fileName
                      }
                      target='_blank'
                      rel='noreferrer'
                    >
                      {document.contactLink}
                    </Link>
                  ) : (
                    <Link
                      href={document.contactLink}
                      target='_blank'
                      rel='noreferrer'
                    >
                      {document.contactLink}
                    </Link>
                  )}
                </Typography>
              </>
            )}
            {!entryAccessCodeConfirmed && (
              <>
                <Divider component='div' sx={{ width: '100%' }} />
                {showAccessCodeFailed && (
                  <Alert
                    severity='error'
                    onClose={() => {
                      setShowAccessCodeFailed(false)
                    }}
                    sx={{ mb: 1 }}
                  >
                    Looks like you used the wrong access code. Access code is
                    case sensitive. Please try again or reach out to the
                    document creators.
                  </Alert>
                )}
                <Stack direction='row' spacing={1} sx={{ mt: '20px' }}>
                  <TextField
                    id='accessCode'
                    variant='outlined'
                    label='Access Code'
                    onChange={handleEntryAccessCode}
                    value={entryAccessCode}
                    onKeyUp={e => e.key === 'Enter' && checkViewCode()}
                    sx={{ width: 400 }}
                    required
                  />

                  <Button
                    variant='contained'
                    onClick={checkViewCode}
                    disabled={entryAccessCode === ''}
                  >
                    Access
                  </Button>
                </Stack>
              </>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}

export default ViewPulse
